import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import moment from 'moment-timezone';

import { TrackingActivity } from '@recruitee/http-types';
import { RtStatefulComponent } from '@recruitee/user-interface';

type State = {
  groupedActivities: Array<{ date: string; activities: TrackingActivity[] }> | null;
};

@Component({
  selector: 'rt-activities-list',
  templateUrl: './activities-list.component.html',
  styleUrls: ['./activities-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivitiesListComponent extends RtStatefulComponent<State> {
  @Input()
  public set activities(activities: TrackingActivity[]) {
    this.setState({ groupedActivities: this.groupActivities(activities) });
  }
  @Input() public shortMessage: boolean = false;
  @Input() public canManageCandidates: boolean = false;

  @Output() public activityItemClick: EventEmitter<TrackingActivity> = new EventEmitter();
  @Output() public readUnreadClick: EventEmitter<{ read: boolean; id: number }> =
    new EventEmitter();

  constructor(protected cdRef: ChangeDetectorRef) {
    super(cdRef);
    this.createState({ groupedActivities: null });
  }

  public groupsTrackBy<T extends { date: string }>(index: number, group: T): string {
    return group.date;
  }

  public activitiesTrackBy(index: number, activity: TrackingActivity): number {
    return activity.id;
  }

  private groupActivities(
    activities: TrackingActivity[],
  ): Array<{ date: string; activities: TrackingActivity[] }> {
    return activities.reduce<Array<{ date: string; activities: TrackingActivity[] }>>(
      (groups, activity) => {
        const date = moment(activity.createdAt).format('D MMMM YYYY');
        const group = groups.find(gp => gp.date === date);

        if (group) {
          group.activities.push(activity);
        } else {
          groups.push({ date: date, activities: [activity] });
        }

        return groups;
      },
      [],
    );
  }
}
